<prism-select 
  [selectOptions]="options"
  [label]="label"
  placeHolder="Select a County"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  [labelClass]="labelClass"
  (onSelected)="emitCounty($event)">
</prism-select>
